import * as React from 'react'
import { Link } from 'gatsby'

const TemplateCardWrapper = ({
  premium = false,
  to,
  href,
  title = null,
  className = '',
  padding = 2,
  // isListing,
  shadow,
  shadowSm,
  children,
}) => {
  const paddings = ['rounded-xl p-1.5', 'rounded-2xl p-3', 'rounded-3xl p-6']

  const classBase = [
    'flex',
    paddings[padding],
    shadow ? 'shadow-hard shadow-gray-200 border-8' : '',
    shadowSm ? 'shadow-hard-sm shadow-gray-200 border-2' : '',
    // isListing ? "" : "flex-col",
    className,
  ]

  const classNameFull = classBase.join(' ')

  if (href) {
    return (
      <a href={href} target={`_blank`} className={classNameFull} title={title}>
        {children}
      </a>
    )
  }

  if (to) {
    return (
      <Link to={to} className={classNameFull} title={title}>
        {children}
      </Link>
    )
  }

  return <div className={classNameFull}>{children}</div>
}

export default TemplateCardWrapper
